import style from "./style.module.css";
const BatchPlusLoader = () => {
  return (
    <div className={style.wrapper}>
      <div>
        {[...new Array(3)]?.map((_, index) => (
          <div key={index} className={style.plan_card_skeleton}></div>
        ))}
      </div>
      <div className={style.loading_section}>
        <div className={style.loader} />
      </div>
    </div>
  );
};

export default BatchPlusLoader;
